class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[name="language_code"], input[name="country_code"]');
    this.button = this.querySelector(".disclosure__button");
    this.panel = this.querySelector(".disclosure__list");
    this.form = this.querySelector("form");
    this.disclosure = this.querySelector(".disclosure");

    if (!this.input || !this.button || !this.panel || !this.form || !this.disclosure) return;

    this.button.addEventListener("click", () => this.toggleSelector());
    this.button.addEventListener("focusout", (event) => this.closeSelector(event));
    this.addEventListener("keyup", (event) => this.onContainerKeyUp(event));

    this.querySelectorAll(".disclosure__list a[data-value]").forEach((item) => {
      item.addEventListener("click", (event) => this.onItemClick(event));
    });
  }

  hidePanel() {
    this.button.setAttribute("aria-expanded", "false");
    this.disclosure.classList.remove("open-currency");
  }

  showPanel() {
    this.button.setAttribute("aria-expanded", "true");
    this.disclosure.classList.add("open-currency");
  }

  toggleSelector() {
    if (this.button.getAttribute("aria-expanded") === "true") {
      this.hidePanel();
      return;
    }

    this.showPanel();
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    this.hidePanel();
    this.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();

    const value = event.currentTarget.dataset.value;
    if (!value || value === this.input.value) return;

    this.input.value = value;

    if (typeof this.form.requestSubmit === "function") {
      this.form.requestSubmit();
    } else {
      this.form.submit();
    }
  }

  closeSelector(event) {
    if (!this.contains(event.relatedTarget)) {
      this.hidePanel();
    }
  }
}

if (!customElements.get("localization-form")) {
  customElements.define("localization-form", LocalizationForm);
}
